module.exports = __webpack_public_path__ + "static/media/bp-right.28baf82f.png";